import * as Styled from "./styles";
import { FunctionComponent } from "react";

const content = (
  <span>
    By inscribing your mark as a representation of your signature (hereafter referred to as "E-Signature") through the
    use of a keypad, mouse, or other device, and by clicking the "Authorize" button, you confirm you agree to and accept
    1) the account transfer electronically and 2) the Authorization. You agree that your E-Signature is the legal
    equivalent of your manual/handwritten signature. You also agree that no certification authority or other third party
    verification is necessary to validate your E-Signature and that the lack of such certification or third party
    verification will not in any way affect the enforceability of your E-Signature or any resulting contract among
    relevant parties. You also represent that you are authorized to provide this E-Signature for your account with
    Manifest.
  </span>
);
const futuremoneyContent = (fullName?: string) => (
  <>
    I {fullName ? `, ${fullName}, ` : ""} verify that I have reviewed and accept the agreements and disclosures for my
    account. I acknowledge that I will be providing an electronic signature to open my account. I understand that the
    Altruist Financial LLC Customer Agreement contains a predispute arbitration clause in Section 27. I agree and
    acknowledge Futuremoney's{" "}
    <a href="https://www.futuremoney.co/legal-privacy" target="_blank" rel="noreferrer">
      Terms and Conditions
    </a>
    ,{" "}
    <a
      href="https://legal.futuremoney.co/FutureMoney+RIA+-+Investment+Management+Agreement.pdf"
      target="_blank"
      rel="noreferrer"
    >
      Investment Management Agreement
    </a>
    ,{" "}
    <a href="https://altruist.com/legal/" target="_blank" rel="noreferrer">
      Altruist customer agreements and disclosures
    </a>
    ,{" "}
    <a href="https://altruist.com/legal/" target="_blank" rel="noreferrer">
      Altruist Roth Individual Retirement Custodial Account Agreement
    </a>
    ,{" "}
    <a href="https://altruist.com/legal/" target="_blank" rel="noreferrer">
      Altruist Electronic Delivery Consent Agreement
    </a>
    , and I acknowledge my advisor's disclosures (
    <a href="https://reports.adviserinfo.sec.gov/reports/ADV/329835/PDF/329835.pdf" target="_blank" rel="noreferrer">
      Part 1
    </a>
    ,{" "}
    <a
      href="https://files.adviserinfo.sec.gov/IAPD/Content/Common/crd_iapd_Brochure.aspx?BRCHR_VRSN_ID=969457"
      target="_blank"
      rel="noreferrer"
    >
      2A
    </a>
    ,{" "}
    <a href="https://reports.adviserinfo.sec.gov/crs/crs_329835.pdf" target="_blank" rel="noreferrer">
      3
    </a>
    ). I agree to participate in the Fully Paid Lending Program, which provides the opportunity to earn additional
    monthly income on stock and ETF positions I already own. I opt-in to the dividend reinvestment program ("DRIP") for
    stocks and ETFs (mutual funds are enrolled in the DRIP by default). I agree to participate in the Bank Sweep
    Program, which enables my cash balances to earn interest while awaiting investment, through FDIC-insured deposits at{" "}
    <a
      href="https://altruist.com/legal/altruist-financial-llc-participating-bank-list/"
      target="_blank"
      rel="noreferrer"
    >
      partner banks
    </a>
    .
    <br />
    <br />
    I certify, under penalties of perjury, that the number shown on this application is my correct Taxpayer
    Identification Number, I am a U.S. person and FATCA reporting does not apply.
    <br />
    <br />
    The Internal Revenue Service does not require your consent to any provision of this document other than the
    certifications required to avoid backup withholding.
  </>
);

export type LegalDisclaimerProps = {
  scrollable?: boolean;
  hasTermsAgreed?: boolean;
  toggleTermsAgreement?: (e: boolean) => void;
  isFuturemoney: boolean;
  fullName?: string;
};

const LegalDisclaimer: FunctionComponent<LegalDisclaimerProps> = ({
  isFuturemoney,
  fullName,
}: LegalDisclaimerProps) => {
  return (
    <Styled.LegalDisclaimerContainer>
      <Styled.CustomScrollbar>
        {content}
        <br />
        <br />
        {isFuturemoney && futuremoneyContent(fullName)}
      </Styled.CustomScrollbar>
    </Styled.LegalDisclaimerContainer>
  );
};

export default LegalDisclaimer;
